import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import Helmet from 'react-helmet';
import { browserHistory } from 'react-router';
import NoSearchResults from './NoSearchResults';
import SearchLoader from './SearchLoader';
import ProductCard from './ProductCard';
import { clickSearchFacet } from '../../actions/productActions';
import config from "../../config";

class SearchResults extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sortHigh: false,
			sortLow: false,
			products: []
		};
	}

	clickSortHigh(event) {
		clickSearchFacet('priceSort', event, !this.state.sortHigh);
		this.setState({
			sortHigh: !this.state.sortHigh,
			sortLow: false
		});
		global.dataLayer.push({
			event: 'Find Your Safe',
			eventCategory: 'Find Your Safe',
			eventAction: 'sort by',
			eventLabel: 'low to high'
		});
	}

	clickSortLow(event) {
		clickSearchFacet('priceSort', event, !this.state.sortLow);
		this.setState({
			sortLow: !this.state.sortLow,
			sortHigh: false
		});
		global.dataLayer.push({
			event: 'Find Your Safe',
			eventCategory: 'Find Your Safe',
			eventAction: 'sort by',
			eventLabel: 'high to low'
		});
	}

	addToCompare(event) {
		const productArr = this.state.products;
		const index = productArr.indexOf(event);

		if (index > -1) {
			productArr.splice(index, 1);
			this.setState({ products: productArr });
		} else {
			this.setState({ products: this.state.products.concat(event) });
		}
	}

	clickCompare() {
		if (this.state.products.length > 4) {
			alert('Please select a maximum of 4 products to compare.'); // eslint-disable-line no-alert
		} else if (this.state.products.length < 2) {
			alert('Please select at least 2 products to compare.'); // eslint-disable-line no-alert
		} else {
			console.dir(`execute ${this.state.products}`);
			browserHistory.push(`/product-compare/${this.state.products}`);
		}
	}

	render() {
		const { products } = this.props;
		let pageTitle = products.pageTitle;
		if (products.pageTitle == 'Fire Safe') {
			pageTitle = "Fire Safe and Fire Bag"
		}

		console.dir(products.products);
		const cards = products.products.map((product, index) => (
			<ProductCard
				key={index}
				product={product}
				addToCompare={event => this.addToCompare(event)}
				clickCompare={() => this.clickCompare()}
				canCompare={
					this.state.products.length >= 2 && this.state.products.length <= 4
				}
			/>
		));
		return (
			<div className="row">
				<Helmet>
					<title>
						{pageTitle ? pageTitle : 'Find The Safe That\'s Right For You'} | SentrySafe
					</title>
					<meta
						name="description"
						content={products.metaDescription ? products.metaDescription : 'Designed with you in mind, our safes offer unique features to protect your most valuable items. Find the safe that\'s right for you.'}
					/>
				</Helmet>
				<Helmet defer={false}>
					<script async src={config.bazaarVoiceScriptUrl} />
				</Helmet>
				<div className="col sm-9">
					<h2 className="products-found">
						<b>{products.productsFound}</b>
						{pageTitle ? ` ${pageTitle}` : ''}
						{products.productsFound === 1 ? ' product' : ' products'} found
					</h2>
					<SearchLoader />
				</div>
				<div className="col sm-3 sort-options">
					Sort by price
					<div className="sorting">
						<span onClick={() => this.clickSortHigh('asc')}>
							<span
								className={`fa fa-angle-up ${this.state.sortHigh ? 'active' : ''}`}
								aria-hidden="true"
							/>
							<span className="assistive-text">ascending</span>
						</span>
						<span onClick={() => this.clickSortLow('desc')}>
							<span
								className={`fa fa-angle-down ${this.state.sortLow ? 'active' : ''}`}
								aria-hidden="true"
							/>
							<span className="assistive-text">descending</span>
						</span>
					</div>
				</div>
				<ul className="product-list">
					{products.products.length > 0 ? cards : <NoSearchResults />}
				</ul>
			</div>
		);
	}
};

export default branch({
	products: ['productSearchResults']
}, SearchResults);


// WEBPACK FOOTER //
// ./src/pages/productSearch/SearchResults.js